import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-couponOwnShipTriangleDisabled",
  "use": "icon-couponOwnShipTriangleDisabled-usage",
  "viewBox": "0 0 6 21",
  "content": "<symbol viewBox=\"0 0 6 21\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-couponOwnShipTriangleDisabled\">\n<path d=\"M5.97142 0L0 21V0H5.97142Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol